var exports = {
  "W": "x127c5a35--a77b25--labels",
};

module.exports = exports;
